import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateWidgetMutation } from "../graphql/mutations";
import type {
  CreateWidgetMutationType,
  CreateWidgetMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateWidgetMutation = (
  options?: MutationHookOptions<
    CreateWidgetMutationType,
    CreateWidgetMutationVariablesType
  >
) => {
  return useMutation<
    CreateWidgetMutationType,
    CreateWidgetMutationVariablesType
  >(CreateWidgetMutation, options);
};
